import { z } from 'zod'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { dateOrIsoString } from '~/prix/types/date'

export const propertyMachineryObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid().nullish(),
  residence: residenceObject.nullish(),
  machineryType: z.string().max(32).nullish(),
  quantity: z.number().int().nullish(),
  description: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  clientId: z.number().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
})

export type PropertyMachineryType = z.infer<typeof propertyMachineryObject>
